import { InputSelectOption } from "src/types";
import { create } from "zustand";

interface LicenseTypesState {
  licenseTypes: InputSelectOption[];
  setLicenseTypes: (licenseTypes: InputSelectOption[]) => void;
}

export const useLicenseTypesStore = create<LicenseTypesState>()((set) => ({
  licenseTypes: [],
  setLicenseTypes: (licenseTypes) => set({ licenseTypes }),
}));
